import { Button, StatusButton } from "@/aptim/aptim";
export default function ThemePage() {
  return (
    <div className="bg-white h-screen p-4 grid grid-cols-12 gap-2">
      <div className="col-span-12">
        <h1 className="text-xl text-primary mb-2">Buttons...</h1>
        <div className="flex gap-2 flex-wrap">
          <Button>Default</Button>
          <Button variant="destructive">Destructive</Button>
          <Button variant="outline">Outline</Button>
          <Button variant="secondary">Secondary</Button>
          <Button variant="ghost">Ghost</Button>
          <Button variant="link">Link</Button>
        </div>
      </div>
      <div className="col-span-12">
        <h1 className="text-xl text-primary mb-2">Status Buttons...</h1>
        <div className="flex gap-2 flex-wrap">
          <StatusButton type="submit" message="message" status="idle">
            Default Idle
          </StatusButton>
          <StatusButton type="submit" message="message" status="pending">
            Default Pending
          </StatusButton>
          <StatusButton
            type="submit"
            message="message"
            status="success"
            variant="destructive"
          >
            Destructive Success
          </StatusButton>
        </div>
      </div>
    </div>
  );
}
